import type { UserDetailRaw, UserDetailUI, UserListRaw, UserRow } from "~/features/admin/users/types";

function toUserRow(raw: UserListRaw): UserRow {
  return {
    id: raw.id,
    displayName: raw.displayName ?? "",
    email: raw.email,
    createdAt: raw.createdAt,
    organization: raw.organization,
    productRoles: raw.userProductRoles.map((upr) => ({
      productName: upr.product.name,
      roleName: upr.role.name,
    })),
    segments: raw.userUserSegments.map((uus) => uus.userSegment.name),
    groups: raw.userUserGroups.map((uug) => uug.userGroup.name),
    memo: raw.memo ?? "",
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}

export function toUserRowList(raws: readonly UserListRaw[]): UserRow[] {
  return raws.map(toUserRow);
}

export function toUserDetailUI(raw: UserDetailRaw): UserDetailUI {
  const byProduct = raw.userProductRoles.reduce<Map<string, string[]>>((acc, upr) => {
    const roles = acc.get(upr.product.name) ?? [];
    roles.push(upr.role.name);
    acc.set(upr.product.name, roles);
    return acc;
  }, new Map());

  return {
    id: raw.id,
    displayName: raw.displayName ?? "",
    email: raw.email ?? "",
    organization: raw.organization,
    memo: raw.memo ?? "",
    createdAt: raw.createdAt,
    updatedAt: raw.updatedAt,
    deactivatedAt: raw.deactivatedAt ?? null,
    productRoles: Array.from(byProduct, ([productName, roles]) => ({ productName, roles })),
    segments: raw.userUserSegments.map((uus) => uus.userSegment.name),
    groups: raw.userUserGroups.map((uug) => uug.userGroup.name),
  };
}
